//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DateTimeModel from 'ui-kit/src/mixins/DateTimeModel';

export default {
    mixins: [
        DateTimeModel,
    ],

    props: {
        title: String,
        message: String,
        minDate: Number,
        maxDate: Number,
        defaultTime: String,
        noDate: Boolean,
        noSignedBy: Boolean,
        withEmail: Boolean,
        signedByFilter: Array,
    },

    data() {
        return {
            model: Date.now(),
            signedBy: null,
            email: '',
        };
    },

    computed: {
        autoSignedBy() {
            return this.signedByFilter?.length === 1;
        },
        signedByFilterFn() {
            return this.signedByFilter && (p => $.findById(this.signedByFilter, p.id));
        },
    },

    watch: {
        signedBy(val) {
            if (val) {
                this.email = val.email;
            }
        },
    },

    methods: {
        show() {
            this.$refs.dialog.show();
        },
        hide() {
            this.$refs.dialog.hide();
        },
        onHide() {
            this.$emit('hide');
        },
        onOk() {
            this.$emit('ok', {
                date: this.model,
                signedBy: this.signedBy,
                email: this.email,
            });
            this.hide();
        },
        onCancel() {
            this.hide();
        },
    },

    mounted() {
        if (this.autoSignedBy) {
            this.signedBy = this.signedByFilter[0];
        }
    },
};
